var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "kb-embed-panel-fade" } }, [
    _vm.visible
      ? _c("div", { staticClass: "embedding-progress-panel" }, [
          _c(
            "div",
            {
              staticClass: "panel-card",
              class: {
                "panel-card--dual": _vm.showUpload && _vm.showEmbedding,
              },
            },
            [
              _vm.showUpload
                ? _c(
                    "div",
                    { staticClass: "panel-segment panel-segment--upload" },
                    [
                      _c("div", { staticClass: "segment-icon" }, [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("cloud_upload"),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "segment-body" },
                        [
                          _c("div", { staticClass: "segment-title" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("chatbotv2.embeddingPanelUploadTitle")
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("a-progress", {
                            attrs: {
                              percent: _vm.uploadPercent,
                              "stroke-color": {
                                "0%": "#1890ff",
                                "100%": "#40a9ff",
                              },
                              status: "active",
                            },
                          }),
                          _vm._v(" "),
                          _vm.uploadTotal > 1
                            ? _c("div", { staticClass: "segment-meta" }, [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(_vm.uploadCompleted) +
                                    " / " +
                                    _vm._s(_vm.uploadTotal) +
                                    " " +
                                    _vm._s(_vm.$t("chatbotv2.filesCompleted")) +
                                    "\n                    "
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "segment-hint" }, [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("info"),
                            ]),
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.$t("chatbotv2.dontLeavePageUpload")
                                ) +
                                "\n                    "
                            ),
                          ]),
                        ],
                        1
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showUpload && _vm.showEmbedding
                ? _c("div", { staticClass: "panel-divider" })
                : _vm._e(),
              _vm._v(" "),
              _vm.showEmbedding
                ? _c(
                    "div",
                    { staticClass: "panel-segment panel-segment--embed" },
                    [
                      _c("div", { staticClass: "segment-icon" }, [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("auto_awesome"),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "segment-body" },
                        [
                          _c("div", { staticClass: "segment-title" }, [
                            _vm._v(
                              _vm._s(_vm.$t("chatbotv2.embeddingPanelTitle"))
                            ),
                          ]),
                          _vm._v(" "),
                          _c("a-progress", {
                            attrs: {
                              percent: _vm.embedPercent,
                              "stroke-color": {
                                "0%": "#52c41a",
                                "100%": "#95de64",
                              },
                              status: "active",
                            },
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "segment-meta" }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.embedCompleted) +
                                " / " +
                                _vm._s(_vm.embedTotal) +
                                " · " +
                                _vm._s(_vm.embedPercent) +
                                "%\n                    "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "segment-hint" }, [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("info"),
                            ]),
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.$t("chatbotv2.dontLeaveWhileEmbedding")
                                ) +
                                "\n                    "
                            ),
                          ]),
                        ],
                        1
                      ),
                    ]
                  )
                : _vm._e(),
            ]
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }